const EmailAdresses = ["office@heliant.rs"];

export default EmailAdresses;
